var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMouse(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 22C24 24.1217 23.1571 26.1566 21.6569 27.6569C20.1566 29.1571 18.1217 30 16 30C13.8783 30 11.8434 29.1571 10.3431 27.6569C8.84285 26.1566 8 24.1217 8 22V10C8 7.87827 8.84285 5.84344 10.3431 4.34315C11.8434 2.84285 13.8783 2 16 2C18.1217 2 20.1566 2.84285 21.6569 4.34315C23.1571 5.84344 24 7.87827 24 10V22ZM16 0C13.3478 0 10.8043 1.05357 8.92893 2.92893C7.05357 4.8043 6 7.34784 6 10V22C6 24.6522 7.05357 27.1957 8.92893 29.0711C10.8043 30.9464 13.3478 32 16 32C18.6522 32 21.1957 30.9464 23.0711 29.0711C24.9464 27.1957 26 24.6522 26 22V10C26 7.34784 24.9464 4.8043 23.0711 2.92893C21.1957 1.05357 18.6522 0 16 0Z",
    fill: "#37384B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7071 6.29289C16.5196 6.10536 16.2652 6 16 6C15.7348 6 15.4804 6.10536 15.2929 6.29289C15.1054 6.48043 15 6.73478 15 7V11C15 11.2652 15.1054 11.5196 15.2929 11.7071C15.4804 11.8946 15.7348 12 16 12C16.2652 12 16.5196 11.8946 16.7071 11.7071C16.8946 11.5196 17 11.2652 17 11V7C17 6.73478 16.8946 6.48043 16.7071 6.29289Z",
    fill: "#5F1314"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMouse);
export default __webpack_public_path__ + "static/media/mouse.b2a5d0c7b18461062f0cd48ed396feb0.svg";
export { ForwardRef as ReactComponent };